import { AsyncPipe, CommonModule, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCard, MatCardModule } from "@angular/material/card";
import { MatChipInputEvent, MatChipsModule } from "@angular/material/chips";
import
{
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose, MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store } from "@ngxs/store";
import { Observable, timer } from "rxjs";
import { EditMultipleDialogData } from "../../../interfaces";
import
{
  Product,
  UpdateProductRequestModel,
} from "../../../services/api";
import { ProductApiStatusState, PutProduct } from "../../product/state";
import { SubscriptionHandlerComponent } from "../subscription-handler/subscription-handler.component";

@Component({
  selector: 'app-edit-multiple-dialog',
  templateUrl: './edit-multiple-dialog.component.html',
  styleUrl: './edit-multiple-dialog.component.css',
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatChipsModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDialogTitle,
    AsyncPipe,
    MatCard,
    MatDialogActions,
    NgIf,
    MatDialogClose,
    MatDialogModule,
    MatInputModule,
    MatCardModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditMultipleDialogComponent extends SubscriptionHandlerComponent
{
  editedValue$: Observable<boolean | null> = this.store.select(ProductApiStatusState.editedValue);

  readonly values = signal([] as string[]);

  product: Product;

  // Edit button pressed flag
  editPressed: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: EditMultipleDialogData,
    private store: Store,
    private dialogRef: MatDialogRef<EditMultipleDialogComponent>)
  {
    super();
    this.values.update(values => [...values, ...data.values]);
  }

  areArraysEqual(arr1: string[], arr2: string[]): boolean
  {
    if (!arr1 || !arr2)
    {
      return false;
    }
    if (arr1.length !== arr2.length)
    {
      return false;
    }
    return arr1.every(value => arr2.includes(value)) && arr2.every(value => arr1.includes(value));
  }

  remove(value: string)
  {
    this.values.update(values =>
    {
      const index = values.indexOf(value);
      if (index < 0)
      {
        return values;
      }
      values.splice(index, 1);
      return [...values];
    });
  }

  add(event: MatChipInputEvent): void
  {
    const value = (event.value || '').trim();

    if (value && !this.values().includes(value))
    {
      this.values.update(values => [...values, value]);
    }

    event.chipInput!.clear();
  }

  editValue()
  {
    this.editPressed = true;
    if (this.data.property === "Product")
    {
      if (this.data.field === "Jira IDs")
      {
        let updatedProduct: UpdateProductRequestModel = {
          id: this.product.id,
          jiraIds: this.values()
        }
        this.store.dispatch(new PutProduct(updatedProduct));
      }
    }

    //Close the dialog 2 seconds after editing
    this.subscribeTo(this.editedValue$, x =>
    {
      if (x) timer(2000).subscribe(() => this.dialogRef.close(true));
    });
  }
}
